import React from 'react';
import { motion } from 'framer-motion';
import '../../styles/LoadingSpinner.css';

const LoadingSpinner = ({ message = 'Memuat data...', size = 'medium', type = 'default' }) => {
  const sizeMap = {
    small: 40,
    medium: 60,
    large: 80
  };

  const spinnerSize = sizeMap[size] || sizeMap.medium;

  // Different loading animations
  const renderSpinner = () => {
    switch (type) {
      case 'dots':
        return (
          <div className="loading-dots-container">
            {[0, 1, 2].map((index) => (
              <motion.div
                key={index}
                className="loading-dot"
                animate={{
                  y: [0, -20, 0],
                  scale: [1, 1.2, 1]
                }}
                transition={{
                  duration: 0.6,
                  repeat: Infinity,
                  delay: index * 0.2
                }}
              />
            ))}
          </div>
        );

      case 'pulse':
        return (
          <motion.div
            className="loading-pulse"
            animate={{
              scale: [1, 1.2, 1],
              opacity: [0.5, 1, 0.5]
            }}
            transition={{
              duration: 1.5,
              repeat: Infinity,
              ease: "easeInOut"
            }}
            style={{ width: spinnerSize, height: spinnerSize }}
          />
        );

      case 'spinner':
      default:
        return (
          <motion.div
            className="loading-spinner-circle"
            animate={{ rotate: 360 }}
            transition={{
              duration: 1,
              repeat: Infinity,
              ease: "linear"
            }}
            style={{ width: spinnerSize, height: spinnerSize }}
          />
        );
    }
  };

  return (
    <div className="loading-spinner-wrapper">
      <div className="loading-spinner-content">
        {renderSpinner()}
        {message && (
          <motion.p
            className="loading-message"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
          >
            {message}
          </motion.p>
        )}
      </div>
    </div>
  );
};

export default LoadingSpinner;
